//frontend/src/site/templates/TemplateCorretorLovable/components/TestimonialsSection.jsx
import { Quote, Star } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: 'Marina Santos',
    role: 'Compradora',
    content:
      'O Ricardo foi excepcional em todo o processo de compra do nosso apartamento. Sua paciência, conhecimento do mercado e atenção aos detalhes fizeram toda a diferença.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Carlos Eduardo',
    role: 'Investidor',
    content:
      'Trabalho com o Ricardo há anos e sempre confio em suas recomendações de investimento. Profissionalismo e transparência são suas marcas registradas.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Fernanda Lima',
    role: 'Vendedora',
    content:
      'Vendeu meu imóvel em tempo recorde e pelo valor que eu esperava. Sua estratégia de marketing e negociação são impressionantes.',
    rating: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <section
      id="depoimentos"
      className="py-24 lg:py-32 bg-section-testimonials text-foreground"
    >
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-gold font-medium tracking-wider text-sm uppercase mb-4">
            Depoimentos
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl font-semibold leading-tight mb-6">
            O Que Dizem Meus Clientes
          </h2>
          <p className="text-muted-foreground">
            A satisfação dos meus clientes é minha maior conquista. Confira
            alguns depoimentos de quem já realizou negócios comigo.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="relative p-8 bg-card rounded-2xl border border-border hover:border-gold/50 transition-colors shadow-card"
            >
              <Quote className="w-10 h-10 text-gold mb-6" />

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-gold fill-gold" />
                ))}
              </div>

              <p className="text-muted-foreground leading-relaxed mb-6">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center">
                  <span className="font-serif text-lg font-semibold text-gold">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-foreground">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
